import React from 'react';

import { IEventRound } from '../../../../store/admin/eventRounds/store';

import Button from '../../../../components/Button';

const ResultsFooter = (
  onToggleEdit: () => void,
  onCancelEdit: () => void,
  onSave: () => void,
  editMode: boolean,
  rounds: IEventRound[],
  onChangeRound: (roundId: string) => () => void,
  roundId: number
) => (onReset: any) => (
  <div className="table-actions">
    <div>SCORECARDS BY ROUND:</div>

    {rounds.map(round => (
      <Button
        key={`round-selector-${round.id}`}
        color="primary"
        variant={String(roundId) === String(round.id) ? 'contained' : 'outlined'}
        onClick={onChangeRound(String(round.id))}
        className="round-selector"
      >
        {round.order + 1}
      </Button>
    ))}

    <div className="right-actions">
      {editMode ? (
        <>
          <Button color="primary" onClick={onReset}>
            RESET
          </Button>

          <Button color="primary" variant="outlined" onClick={onCancelEdit}>
            CANCEL
          </Button>

          <Button color="primary" variant="contained" onClick={onSave}>
            Save
          </Button>
        </>
      ) : (
        <>
          <Button color="primary">Withdraw</Button>

          <Button color="primary" onClick={onToggleEdit}>
            EDIT
          </Button>
        </>
      )}
    </div>
  </div>
);

export default ResultsFooter;
